import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE;

export default function CompleteProfile() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    company: '',
    address: '',
    role: '',
    source: '',
  });

  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/users/profile`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('Profile updated successfully!');
        setMessageType('success');
        setTimeout(() => navigate('/dashboard'), 1000);
      } else {
        setMessage(data.message || 'Something went wrong');
        setMessageType('error');
      }
    } catch (err) {
      setMessage('Error updating profile');
      setMessageType('error');
    }

    setIsLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-6 bg-white rounded shadow-md">
        <h2 className="text-xl font-semibold mb-4 text-center text-gray-700">
          Complete Your Profile
        </h2>

        {message && (
          <div
            className={`mb-4 p-3 rounded text-sm ${
              messageType === 'success'
                ? 'bg-green-100 text-green-700 border border-green-300'
                : 'bg-red-100 text-red-700 border border-red-300'
            }`}
          >
            {message}
          </div>
        )}

        <input
          className="w-full p-2 border rounded mb-4"
          name="company"
          placeholder="Company Name"
          value={formData.company}
          onChange={handleChange}
        />
        <input
          className="w-full p-2 border rounded mb-4"
          name="address"
          placeholder="Address"
          value={formData.address}
          onChange={handleChange}
        />
        <input
          className="w-full p-2 border rounded mb-4"
          name="role"
          placeholder="Your Role / Title"
          value={formData.role}
          onChange={handleChange}
        />

        <select
          name="source"
          value={formData.source}
          onChange={handleChange}
          className="w-full p-2 border rounded mb-4"
        >
          <option value="">How did you hear about us?</option>
          <option value="linkedin">LinkedIn</option>
          <option value="referral">Referral</option>
          <option value="google">Google Search</option>
          <option value="other">Other</option>
        </select>

        <div className="flex justify-between items-center">
          <button
            onClick={() => navigate('/dashboard')}
            className="text-sm text-gray-500 hover:underline"
          >
            Skip for now
          </button>
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            className="bg-primary text-white px-4 py-2 rounded hover:bg-red-600 transition"
          >
            {isLoading ? 'Saving...' : 'Save and Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
